import linker from '@/web3-server/utils/linker';
const web3Constants = {
    maxNumOfCardsInBoosting: process.env.VUE_APP_MAX_NUM_CARDS_BOOSTING || '20',
    crossChainSlippage: {
        forCalc: linker.decimal.getSimple('0.001'),
        toShow: '0.1',
    },
};
export default web3Constants;
